export default {
  PRIMARY_COLOR: '#31c570',
  SECONDARY_COLOR: '#000099', // same as DARK_BLUE
  WARNING: '#ffcc00',
  ERROR: '#E53935',
  LINK_COLOR: '#2D5E7D',
  DARK_BLUE: '#000099',
  DARK_BLUE_MAP: '#0066ff',
  DARK_BLUE_BORDER: '#0054a8',
  LIGHT_BLUE: '#87a1c8',
  GRAY: '#666666',
  GRAY_BTN: '#616161',
  GRAY_LIGHT_1: '#757575',
  ORANGE: '#ffa500',

}
